module.exports = __webpack_public_path__ + "img/reward.f4e17fe6.svg";